import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { NeedleSizes } from "./needle-sizes-entity";


@Injectable()
export class NeedleSizesRepository extends Repository<NeedleSizes> {

    constructor(@InjectRepository(NeedleSizes) private needleSizesRepo: Repository<NeedleSizes>
    ) {
        super(needleSizesRepo.target, needleSizesRepo.manager, needleSizesRepo.queryRunner);
    }

    async getAllNeedleSizesQuery(): Promise<any> {
        return await this.createQueryBuilder('ns')
            .select([
                'ns.id AS id',
                'ns.needle_sizes AS needleSizes',
                'ns.is_active AS isActive'
            ])
            .getRawMany();
    }

}